<template>
    <!-- Read-only derived display (e.g. Excursion's "Period 1  19:00 - 07:00").
         Renders no input: the value is computed from other settings.
         data-no-divider: this row has its own card background, so the section's
         divider would cut across it. -->
    <div class="report-settings-static mt-2 flex items-center justify-between gap-4 rounded-md bg-gray-50 px-3 py-3">
        <div class="flex-1">
            <p class="m-0 text-left text-sm font-medium text-gray-700">{{ field.label }}</p>
            <p  v-if="field.description"
                class="m-0 text-left text-sm text-gray-500">
                {{ field.description }}
            </p>
        </div>

        <span class="shrink-0 text-sm text-gray-600">{{ displayValue }}</span>
    </div>
</template>

<script>
export default {
    name: "ReportStaticField",
    props: {
        // Resolved by the panel from `field.value(settings, context)`.
        modelValue: {
            type: [String, Number],
            default: '',
        },
        field: {
            type: Object,
            required: true,
        },
    },
    computed: {
        displayValue() {
            return this.modelValue === null || this.modelValue === ''
                ? '--'
                : this.modelValue
        },
    },
}
</script>
